export const PANEL_WIDTH = 362

export interface Colors {
  [key: string]: string
}

//APP ENV
export const APP_ENV_PRODUCTION_LIST = ['prd', 'production']
